import { useEffect } from 'react';

import { StackProps } from '@mui/material';
import { useBreakpoints } from 'common/hooks';
import { AnimatePresence, motion } from 'framer-motion';
import {
  AlertContext,
  removeAlertsMatchingContext,
  selectLastDialogAlertByContext,
  selectSnackBarAlertsByContext,
} from 'modules/alerts/state';
import { useAppDispatch, useAppSelector } from 'store';

import { AlertsWrapper } from './Alerts.styled';
import { AlertDialogContainer, SnackbarContainer } from './components';

type Props = Pick<StackProps, 'sx'> & {
  context: AlertContext;
  justifyContent?: 'start' | 'center' | 'end';
};

export const AlertsContainer = ({ sx, context, justifyContent = 'center' }: Props) => {
  const dispatch = useAppDispatch();
  const snackbarAlerts = useAppSelector((state) => selectSnackBarAlertsByContext(state, context));
  const lastDialogAlert = useAppSelector((state) => selectLastDialogAlertByContext(state, context));
  const { isMobile } = useBreakpoints();

  useEffect(
    () => () => {
      dispatch(removeAlertsMatchingContext(context));
    },
    [dispatch, context]
  );

  return (
    <>
      {lastDialogAlert && <AlertDialogContainer {...lastDialogAlert} />}

      <AlertsWrapper data-testid="AlertsContainer-snackbarAlerts" sx={sx}>
        <AnimatePresence initial={false}>
          {snackbarAlerts?.map((alert) => (
            <motion.div
              key={alert.id}
              initial={{ opacity: 0, y: isMobile ? -50 : 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
              style={{
                display: 'flex',
                justifyContent,
              }}
            >
              <SnackbarContainer alertData={alert} />
            </motion.div>
          ))}
        </AnimatePresence>
      </AlertsWrapper>
    </>
  );
};
